import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { AuthGuard } from './util/guards/auth-guard.service';
import { RoleGuard } from './util/guards/role-guard.service';
import { Page404NotFoundComponent } from './shared/page404-not-found/page404-not-found.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  { path: 'not-found', component: Page404NotFoundComponent },
  {
    path: 'user-panel', loadChildren: () =>
    import('./content/user-panel/user-panel.module').then (m => m.UserPanelModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {role: 'ROLE_USER'}
  },
  {
    path: 'manager-panel', loadChildren: () =>
    import('./content/manager-panel/manager-panel.module').then (m => m.ManagerPanelModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {role: 'ROLE_MANAGER'}
  },
  {
    path: 'admin-panel', loadChildren: () =>
    import('./content/admin-panel/admin-panel.module').then (m => m.AdminPanelModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {role: 'ROLE_ADMIN'}
  },
  {
    path: '**', redirectTo: 'not-found'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
